import React from 'react';

import PlaybackScreen from '../../../screens/PlaybackScreen';

const PlaybackPage = () => <PlaybackScreen.Main />;

export default PlaybackPage;
